import { Droplets, LayoutPanelTop, Hammer, Waves, ArrowRight } from "lucide-react";
import { PROBLEMS } from "../../data/content";
import { scrollToId } from "../../hooks/useSmoothScroll";
import { Reveal, Overline } from "./Reveal";

const ICONS = { Droplets, LayoutPanelTop, Hammer, Waves };

export default function Problems() {
  return (
    <section data-testid="problems-section" className="relative bg-white bg-dots py-16 sm:py-20 md:py-32">
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <div className="max-w-3xl">
          <Reveal>
            <Overline>A tető nem várhat</Overline>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-5 text-4xl sm:text-5xl font-bold tracking-tight text-[#0E5A75] text-balance">
              Beázik, elöregedett vagy felújításra szorul a tető?
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 text-base sm:text-lg text-slate-600 leading-relaxed">
              Egy sérült vagy nem megfelelően szigetelt tető idővel komolyabb károkat okozhat az
              ingatlanban. Legyen szó kisebb javításról, teljes tetőfelújításról vagy új tetőfedésről,
              szakembereink segítenek megtalálni az épülethez és az igényekhez illő megoldást.
            </p>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {PROBLEMS.map((p, i) => {
            const Icon = ICONS[p.icon];
            return (
              <Reveal key={p.title} delay={i * 0.08}>
                <div
                  data-testid={`problem-card-${i}`}
                  className="group h-full rounded-2xl border border-slate-200 bg-slate-50/60 p-6 hover:bg-white hover:border-emerald-200 hover:shadow-xl hover:shadow-slate-200/60 hover:-translate-y-1 transition-all duration-300"
                >
                  <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-[#0E5A75] text-white group-hover:bg-[#0E5A75] transition-colors">
                    <Icon className="h-6 w-6" />
                  </span>
                  <h3 className="mt-5 text-lg font-bold text-[#0E5A75]">{p.title}</h3>
                  <p className="mt-2 text-sm text-slate-600 leading-relaxed">{p.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={0.1}>
          <div className="mt-12 flex justify-center">
            <button
              data-testid="problems-cta"
              onClick={() => scrollToId("ajanlatkeres")}
              className="group inline-flex items-center gap-2 rounded-full bg-[#0E5A75] px-7 py-4 text-base font-semibold text-white hover:bg-[#0B4A60] hover:scale-[1.03] transition-transform"
            >
              Kérem a tető állapotfelmérését
              <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
